var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex position-relative"
  }, [_c('BaseInputText', {
    staticClass: "w-100 h-100",
    attrs: {
      "name": "searchQuery",
      "placeholder": _vm.searchLabel
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments);
      },
      "input": _vm.searchForAutocomplete
    },
    model: {
      value: _vm.searchQuery,
      callback: function callback($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  }), _c('MottoIcon', {
    class: _vm.$style.searchIcon,
    attrs: {
      "name": "Search"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.search.apply(null, arguments);
      }
    }
  }), _c('ResourceSearchSuggestion', {
    class: _vm.$style.searchSuggestions,
    attrs: {
      "resources": _vm.autocompleteResults
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }